import React, { useState, useContext, useEffect } from "react";
import "../Components/Orders/Orders.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Input, Collapse } from "antd";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import FormatHelper from "../../Helper/FormatHelper";
import { FileOutlined, FileTextOutlined } from "@ant-design/icons";
import { techappContext } from "../../Api/techappReq";
import Colors from "../../Helper/Colors";
import Modal from "react-modal";
import DigitalFactorModal from "./DigitalFactorModal";
import CancelOrderModal from "./CancelOrderModal";
import RejectOrderModal from "./RejectOrderModal";
import ticketOpIcon from "../../assets/images/ticketOp.png";
import AcceptModal from "../Components/accept_modal";
import { toast } from "react-toastify";
import Layout from "../../layout";
import { FaHashtag, FaRegUser, FaRegClock, FaCircle } from "react-icons/fa";
import { FaRegPaste } from "react-icons/fa6";
import { FiCalendar } from "react-icons/fi";
import { IoHomeOutline } from "react-icons/io5";
import { FaTimes } from "react-icons/fa";
import OrderMap from "../Components/order_map";

const { TextArea } = Input;
const { Panel } = Collapse;

const ViewOrder = () => {
  const navigate = useNavigate();
  const order = useSelector((state) => state.TechAppReducer.orderObj);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [digitalFactorVisible, setDigitalFactorVisible] = useState(false);
  const [cancelJob, setCancelJob] = useState(false);
  const [text, setText] = useState("");
  const [showDoc, setShowDoc] = useState(false);
  const [doc, setDoc] = useState(null);
  const [rejectModal, setRejectModal] = useState(false);
  const [acceptModal, setAcceptModal] = useState(false);

  const [orderItems, setOrderItems] = useState(null);

  const { addNote, sendAction, callLogReq, loading, setCreateTicketOrderId } =
    useContext(techappContext);
  const [companyDesc, setCompanyDesc] = useState(false);

  const noteHandler = (e) => {
    setText(e.target.value);
  };

  const openDoc = (doc) => {
    setShowDoc(true);
    setDoc(doc);
  };

  useEffect(() => {
    if (order?.company_desc !== null && order?.company_desc !== "") {
      setCompanyDesc(true);
    }
    if (order) {
      let newItems = {
        doing: [],
        complaint: [],
      };
      order?.items?.data?.forEach((item) => {
        if (item.cost_ann_num === 0) {
          newItems.complaint.push(item);
        } else {
          newItems.doing.push(item);
        }
      });
      setOrderItems(newItems);
    }
  }, []);

  const openActionPage = (action) => {
    setModalIsOpen(false);
    switch (action.id) {
      case 21:
        setDigitalFactorVisible(true);
        break;
      case 5:
        setCancelJob(true);
        break;
      case 8:
        navigate("/techapp/define-cost");
        break;
      case 11:
        navigate("/techapp/complaint");
        break;
      // قبول
      case 6:
        setAcceptModal(true);
        break;
      case 7:
        setRejectModal(true);
        break;
      default:
        break;
    }
  };

  const genExtra = () => (
    <FileOutlined
      style={{ marginLeft: "10px" }}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  const genExtra2 = () => (
    <FileTextOutlined
      style={{ marginLeft: "10px" }}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  return (
    <Layout>
      {order ? (
        <div className="tech-app-view-order">
          {/* header */}
          <div className="tech-app-header">
            <IoIosArrowForward
              style={{ fontSize: "24px", paddingBottom: "5px" }}
              onClick={() => {
                navigate("/techapp");
              }}
            />
            <span
              onClick={() => {
                navigate("/techapp");
              }}
              style={{ marginRight: "10px", cursor: "pointer" }}
            >
              {order?.service?.data?.title}
            </span>
          </div>
          <div className="tech-app-view-order-detail">
            {/* call buttons */}
            {order?.status_id !== 3 &&
            order?.status_id !== 16 &&
            order?.status_id !== 1 ? (
              <div className="tech-app-view-order-doing-numbers-btn">
                {order?.user?.data?.phone ? (
                  <Button
                    onClick={() => callLogReq(order.user.data.phone, order.id)}
                  >
                    {/* <a href={`tel:${order.user.data.phone}`}>تلفن ثابت</a> */}
                    تلفن ثابت
                  </Button>
                ) : null}
                {order?.user?.data?.mobile ? (
                  <Button
                    onClick={() => callLogReq(order.user.data.mobile, order.id)}
                  >
                    {/* <a href={`tel:${order.user.data.mobile}`}>تلفن همراه</a> */}
                    تلفن همراه
                  </Button>
                ) : null}
              </div>
            ) : null}
            {/* name */}
            {order?.status_id !== 3 && order?.status_id !== 16 ? (
              <div className="tech-app-view-order-detail-info-item">
                <FaRegUser />
                {order.user.data.first_name} {order.user.data.last_name}
              </div>
            ) : null}
            {/* unique id */}
            <div className="tech-app-view-order-detail-info-item">
              <FaHashtag />
              {FormatHelper.toPersianString(order.unique_id)}
              <div
                className="tech-app-view-order-detail-info-item-copy-button"
                onClick={() => {
                  navigator.clipboard.writeText(order?.unique_id);
                  toast.success("با موفقیت کپی شد");
                }}
              >
                <FaRegPaste />
                کپی
              </div>
            </div>
            {/* datetime */}
            <div className="tech-app-view-order-detail-info-item">
              <FiCalendar />
              {FormatHelper.toPersianString(order.persian_created_at)}
            </div>
            {/* address */}
            <div
              className="tech-app-view-order-detail-info-item"
              style={
                order?.status_id !== 3 && order?.status_id !== 16
                  ? { flexDirection: "column", alignItems: "flex-start" }
                  : {}
              }
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <IoHomeOutline />
                {order?.status_id !== 3 && order?.status_id !== 16
                  ? order?.address?.data?.fullAddress
                  : (order?.address?.data?.parametric_address || '') +
                    ' - ' +
                    (order?.address?.data?.address?.substring(
                      0,
                      order?.address?.data?.address?.length / 2,
                    ) || '') +
                    '...'}
              </div>
              {order?.status_id !== 3 && order?.status_id !== 16 &&
              order?.address?.data?.lat &&
              order?.address?.data?.lng ? (
                <>
                  <OrderMap
                    lat={order?.address?.data?.lat}
                    lng={order?.address?.data?.lng}
                  />
                  <Button
                    onClick={() => {
                      window.open(
                        `geo:${order.address.data.lat},${order.address.data.lng}?q=${order.address.data.lat},${order.address.data.lng}`,
                        "_blank",
                      );
                    }}
                    style={{ marginTop: 8, alignSelf: "flex-end" }}
                  >
                    نمایش در برنامه مسیریاب
                  </Button>
                </>
              ) : null}
            </div>
            {/* remaining time */}
            {order?.time_to_done_order && order?.time_to_done_order > 2 ? (
              <div className="tech-app-view-order-detail-info-item">
                <FaRegClock />
                <span>
                  {FormatHelper.toPersianString(order?.time_to_done_order_text)}
                </span>
              </div>
            ) : null}
            {order?.time_to_done_order &&
            order?.time_to_done_order < 3 &&
            order?.time_to_done_order > -1 ? (
              <div className="tech-app-view-order-detail-info-item">
                <FaRegClock style={{ color: "#fcc603" }} />
                <span style={{ color: "#fcc603" }}>
                  {FormatHelper.toPersianString(order?.time_to_done_order_text)}
                </span>
              </div>
            ) : null}
            {order?.time_to_done_order && order?.time_to_done_order < 0 ? (
              <div className="tech-app-view-order-detail-info-item">
                <FaRegClock style={{ color: "red" }} />
                <span style={{ color: "red" }}>
                  {FormatHelper.toPersianString(order?.time_to_done_order_text)}
                </span>
              </div>
            ) : null}
          </div>
          {/* desc card */}
          {order?.model_number?.length > 0 ||
          order?.submission_desc?.length > 0 ? (
            <div className="tech-app-view-order-detail">
              {order?.submission_desc?.length > 0 && (
                <div className="tech-app-view-order-detail-question-item">
                  <span>توضیحات</span>
                  <small>{order?.submission_desc}</small>
                </div>
              )}
              {order?.model_number?.length > 0 && (
                <div className="tech-app-view-order-detail-question-item">
                  <span>مدل دستگاه</span>
                  <small>{order?.model_number}</small>
                </div>
              )}
            </div>
          ) : null}
          {/* questions */}
          {order?.details?.data?.length > 0 ? (
            <div className="tech-app-view-order-detail">
              {order.details.data.map((x, index) => (
                <div
                  className="tech-app-view-order-detail-question-item"
                  key={index}
                >
                  <span>
                    {FormatHelper.toPersianString(x.question.data.title)}
                  </span>
                  <small>
                    {FormatHelper.toPersianString(x.answer.data.title)}
                  </small>
                </div>
              ))}
            </div>
          ) : null}
          {/* fee declarate items card */}
          {order?.total_cost ||
          order?.total_cost2 ||
          order?.net_profit ||
          order?.net_profit2 ||
          (order?.items?.data?.length > 0 && orderItems) ? (
            <div className="tech-app-view-order-detail">
              {order?.total_cost ? (
                <div className="tech-app-view-order-detail-question-item">
                  <span>کل مبلغ دریافتی</span>
                  <small>
                    {FormatHelper.toPersianString(
                      FormatHelper.numberSeperator(order?.total_cost)
                    )}{" "}
                    تومان
                  </small>
                </div>
              ) : null}
              {order?.total_cost2 ? (
                <div className="tech-app-view-order-detail-question-item">
                  <span>کل مبلغ دریافتی</span>
                  <small>
                    {FormatHelper.toPersianString(
                      FormatHelper.numberSeperator(order?.total_cost2)
                    )}{" "}
                    تومان
                  </small>
                </div>
              ) : null}
              {order?.net_profit ? (
                <div className="tech-app-view-order-detail-question-item">
                  <span>سود خالص</span>
                  <small>
                    {FormatHelper.toPersianString(
                      FormatHelper.numberSeperator(order?.net_profit)
                    )}{" "}
                    تومان
                  </small>
                </div>
              ) : null}
              {order?.net_profit2 ? (
                <div className="tech-app-view-order-detail-question-item">
                  <span>سود خالص</span>
                  <small>
                    {FormatHelper.toPersianString(
                      FormatHelper.numberSeperator(order?.net_profit2)
                    )}{" "}
                    تومان
                  </small>
                </div>
              ) : null}
              {order?.items?.data?.length > 0 && orderItems ? (
                <div className="tech-app-view-order-detail-question-item">
                  <span>ریز خرج کردها</span>
                  {orderItems?.doing?.length > 0 ? (
                    <div
                      style={
                        orderItems?.complaint?.length > 0
                          ? {
                              borderBottom: "1px solid rgba(200,200,200,.6)",
                              display: "flex",
                              flexDirection: "column",
                              padding: "10px 0",
                            }
                          : { display: "flex", flexDirection: "column" }
                      }
                    >
                      {orderItems?.doing.map((it, index) => (
                        <div
                          key={index}
                          className="tech-app-view-order-detail-items-item"
                        >
                          <span>{it.item} :</span>
                          <span>
                            {FormatHelper.toPersianString(
                              FormatHelper.numberSeperator(it.price)
                            )}{" "}
                            تومان
                          </span>
                          {it?.count ? (
                            <span style={{ marginRight: 5 }}>
                              ({FormatHelper.toPersianString(it.count)} عدد)
                            </span>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  ) : null}
                  {orderItems?.complaint?.length > 0 ? (
                    <div
                      style={
                        orderItems?.complaint?.length > 0
                          ? {
                              display: "flex",
                              flexDirection: "column",
                              padding: "10px 0",
                            }
                          : { display: "flex", flexDirection: "column" }
                      }
                    >
                      {orderItems?.complaint.map((it, index) => (
                        <div
                          key={index}
                          className="tech-app-view-order-detail-items-item"
                        >
                          <span>{it.item} :</span>
                          <span>
                            {FormatHelper.toPersianString(
                              FormatHelper.numberSeperator(it.price)
                            )}{" "}
                            تومان
                          </span>
                          {it?.count ? (
                            <span style={{ marginRight: 5 }}>
                              ({FormatHelper.toPersianString(it.count)} عدد)
                            </span>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          ) : null}
          {/* reciepts */}
          {order.receipt_array.length !== 0 && (
            <Collapse
              className="teach-app-profile-cards"
              style={{ width: "90%", padding: "0 10px", marginTop: "20px" }}
            >
              <Panel extra={genExtra2()} header={"رسید دیجیتال"} key="1">
                {order.receipt_array &&
                  order.receipt_array.map((x, index) => (
                    <div
                      key={index + 30}
                      className="tech-app-view-order-detail"
                      style={{
                        margin: "0",
                        width: "100%",
                        borderRadius: "0",
                        boxShadow: "none",
                      }}
                    >
                      <div style={{ display: "flex", color: "gray" }}>
                        {x !== null && (
                          <>
                            <FaCircle
                              style={{
                                paddingTop: "5px",
                                marginLeft: "10px",
                                fontSize: "12px",
                                color: "black",
                              }}
                            />
                            {FormatHelper.toPersianString(x)}
                          </>
                        )}
                      </div>
                    </div>
                  ))}
              </Panel>
            </Collapse>
          )}
          {/* notes */}
          {order.notes.length > 0 ? (
            <Collapse
              className="teach-app-profile-cards"
              style={{
                width: "90%",
                padding: "0 10px",
                backgroundColor: "rgb(33, 212, 212, 0.40)",
                marginTop: "20px",
              }}
            >
              <Panel extra={genExtra()} header={"یادداشت های من"} key="1">
                {order.notes &&
                  order.notes.map((note, index) => (
                    <div
                      key={index + 50}
                      className="tech-app-view-order-detail"
                      style={{
                        backgroundColor: "rgb(33, 212, 212, 0.40)",
                        margin: "0",
                        width: "100%",
                        borderRadius: "0",
                        boxShadow: "none",
                      }}
                    >
                      <span>
                        {FormatHelper.toPersianString(note.created_at_persian)}
                      </span>
                      <small>{FormatHelper.toPersianString(note.note)}</small>
                    </div>
                  ))}
              </Panel>
            </Collapse>
          ) : null}
          {/* add notes */}
          {order.status_id === 1 ||
          order.status_id === 4 ||
          order.status_id === 7 ? (
            <>
              <TextArea
                autoSize
                style={{ maxHeight: "120px", paddingTop: "10px" }}
                inputMode="text"
                value={text}
                onChange={noteHandler}
                placeholder={
                  "توضیحاتی که نیاز دارید درباره این سفارش داشته باشید"
                }
                className="techapp-done-orders-view-order-comment"
              />
              <Button
                onClick={() => addNote(order.id, text)}
                style={{ backgroundColor: Colors.royalBlue }}
                loading={loading}
                className={"techapp-doneorders-submit-note-btn btn-text-white"}
              >
                ثبت یادداشت
              </Button>
            </>
          ) : null}
          {/* documents */}
          {order.status_id === 1 && order.docs.length > 0
            ? order.docs.map((doc, index) => (
                <div
                  key={index + 60}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-around",
                  }}
                >
                  <img
                    onClick={() => openDoc(doc)}
                    style={{
                      width: "15%",
                      height: "70px",
                      minWidth: "100px",
                      margin: "10px 0",
                      cursor: "pointer",
                      borderRadius: "6px",
                    }}
                    src={doc}
                    alt="docs"
                  />
                </div>
              ))
            : null}
          {showDoc && doc && (
            <Modal
              ariaHideApp={false}
              isOpen={true}
              onRequestClose={() => setShowDoc(false)}
              className="tech-app-view-order-showdoc-modal"
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                },
              }}
            >
              <FaTimes
                onClick={() => setShowDoc(false)}
                style={{
                  color: "white",
                  cursor: "pointer",
                  position: "absolute",
                  right: "30px",
                  top: "20px",
                  fontSize: "22px",
                }}
              />
              <img style={{ width: "60%" }} src={doc} alt="doc" />
            </Modal>
          )}
          {/* digital receipt modal */}
          {digitalFactorVisible && (
            <DigitalFactorModal
              digitalFactorVisible={digitalFactorVisible}
              setDigitalFactorVisible={setDigitalFactorVisible}
            />
          )}
          {/* cancel order modal */}
          {cancelJob && (
            <CancelOrderModal
              cancelJob={cancelJob}
              setCancelJob={setCancelJob}
            />
          )}
          {/* actions modal */}
          {modalIsOpen && (
            <Modal
              ariaHideApp={false}
              isOpen={true}
              onRequestClose={() => setModalIsOpen(false)}
              className="tech-app-view-order-modal"
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.551)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  zIndex: "10000",
                },
              }}
            >
              <p style={{ padding: "10px" }}>
                <IoIosArrowDown
                  style={{ cursor: "pointer", padding: "0 10px" }}
                  onClick={() => setModalIsOpen(false)}
                />
                <span>عملیات</span>
              </p>
              {order?.allowedActions?.data.map((action, index) => {
                if (action.order) {
                  return (
                    <div
                      key={index + 100}
                      onClick={() => openActionPage(action)}
                      style={{
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                        padding: "15px 10px",
                        marginBottom: "20px",
                      }}
                      id={`action_items_${action.id}`}
                    >
                      <img
                        src={action.icon}
                        alt="icon"
                        style={{ width: "20px", marginLeft: "10px" }}
                      />
                      {action.title}
                    </div>
                  );
                }

                return '';
              })}
              {order?.status_id !== 3 && order?.status_id !== 16 && (
                <div
                  onClick={() => {
                    navigate("/techapp/create-ticket");
                    setCreateTicketOrderId(order?.unique_id);
                  }}
                  style={{
                    color: "black",
                    display: "flex",
                    alignItems: "center",
                    padding: "15px 10px",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={ticketOpIcon}
                    alt="icon"
                    style={{ width: "20px", marginLeft: "10px" }}
                  />
                  ارسال تیکت
                </div>
              )}
            </Modal>
          )}
          {/* company description modal */}
          {companyDesc && (
            <Modal
              ariaHideApp={false}
              isOpen={true}
              onRequestClose={() => setCompanyDesc(false)}
              className="tech-app-company-desc-modal"
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.551)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: "10000",
                },
              }}
            >
              <span style={{ color: Colors.warning, fontWeight: 700 }}>
                توضیحات تکمیلی
              </span>
              <div>{order?.company_desc}</div>
              <Button
                onClick={() => setCompanyDesc(false)}
                className="tech-app-reset-data-btns btn-text-white"
                style={{ backgroundColor: Colors.royalBlue, color: "white" }}
              >
                متوجه شدم
              </Button>
            </Modal>
          )}
          {/* reject order modal */}
          {rejectModal && (
            <RejectOrderModal
              rejectModal={rejectModal}
              setRejectModal={setRejectModal}
              loading={loading}
            />
          )}
          {/* accept modal */}
          <AcceptModal
            open={acceptModal}
            setOpen={setAcceptModal}
            confirmAction={() => sendAction(6)}
            loading={loading}
          />
          {/* action button */}
          <div className="view-order-action-button">
            <Button
              onClick={() => setModalIsOpen(true)}
              className="tech-app-operation-button btn-text-white"
              style={{ backgroundColor: Colors.royalBlue }}
              disabled={loading}
            >
              عملیات
            </Button>
          </div>
        </div>
      ) : null}
    </Layout>
  );
};
export default ViewOrder;
